import React from 'react'
import styled from 'styled-components';
import hardwareData from '../../data/hardwareData';
import HardwareProduct from './HardwareProduct'

const Hardwares = () => {
    const products = hardwareData();
    return (
        <Container>
            <div className="heading">
                <span>Our Products</span>
                <h4>Our World Class Hardware Products Gives You An Experience You Will Never Forget</h4>
            </div>
            <HardwareProducts>
                {
                    products.map(item => (
                        <HardwareProduct
                            item={item}
                        />
                    ))
                }
            </HardwareProducts>
        </Container>
    )
}

export default Hardwares

const Container = styled.div`
    background: #fff;
    .heading{
        text-align: center;
        padding: 0rem 10rem;
        padding-bottom: 1rem;
        span{
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
        color: #e21f36;
        }
        h4{
            color: #000219;
            font-size: 2rem;
            font-weight: 800;
        }
        p{
            color: #000219;
            font-size: 1.2rem;
        }
        @media screen and (max-width: 900px){
            padding: 0rem 0.5rem;
            /* h4{
                font-size: 1rem;
            } */
        }
    }
`

const HardwareProducts = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`